import React, {useEffect, useState} from 'react';
import {createRestaurant} from "../../Services/RestarantDetailsService";
import axios from "axios";
import {axiosLogin} from "../services/loginService";
import {useHistory} from "react-router-dom";
import NavigationBar from "../NavigationBar";

export const RestaurantEdit = () => {
    const history = useHistory();
    const [userId, setUserId] =  useState("");
    const [user, setUser] =  useState({user:"", uType:""});
    const [restaurantId, setRestaurantId] = useState(1);
    const [menuItems, setMenuItems] = useState([]);
    const [restaurant, setRestaurant] = useState(
        {restaurant_name:"",restaurant_phone:"",restaurant_website:"", hours:"",price_range:"$$",
        restaurant_id:0 });
    const [restaurantAddress, setRestaurantAddress] = useState({address: '', city:'', state:'',
        postal_code:0, street:'', formatted:''});
    const [geo, setGeo] = useState({lat:0, lon:0});
    const [menuItem, setMenuItem] = useState({name:"", description:"",section_name:"", price:0.0});

    const addItemClickHandler = () => {
        setMenuItems([...menuItems, menuItem])
    }
    const deleteItemClickHandler = (item) => {
        let itemsList = menuItems.filter(it => it !== item)
        setMenuItems([...itemsList])
    }
    const itemNameChangeHandler = (event) => {

        setMenuItem({...menuItem, name: event.target.value});
    }
    const itemDescChangeHandler = (event) => {

        setMenuItem({...menuItem, description:event.target.value });
    }
    const itemPriceChangeHandler = (event) => {
        setMenuItem({...menuItem, price: event.target.value});
    }
    const itemSectionChangeHandler = (event) =>{
        setMenuItem({...menuItem, section_name: event.target.value});
    }
    const  restaurantNameChangeHandler = (event) =>{
        setRestaurant({...restaurant, restaurant_name: event.target.value })
    }
    const  phoneChangeHandler = (event) => {
        setRestaurant({...restaurant,restaurant_phone: event.target.value })
    }
    const  websiteChangeHandler = (event) => {
        setRestaurant({...restaurant,restaurant_website: event.target.value })
    }
    const  hoursChangeHandler = (event) => {
        setRestaurant({...restaurant,hours: event.target.value })
    }
    const  priceChangeHandler = (event) => {
        setRestaurant({...restaurant,price_range: event.target.value })
    }
    const  idChangeHandler = (event) => {
        let val =event.target.value;
        if((typeof val === 'string') && !val.includes('\.') && !val.includes('e')&&
            !val.match("/^\\d+$/"))
            setRestaurant({...restaurant,restaurant_id: event.target.value })
        setRestaurantId(restaurant.restaurant_id)

    }
    useEffect(() =>{
        axiosLogin().then(response => {
                setUserId(response.data.userId)
                setUser(response.data)
            }
        ).catch((e) => {
            alert("Login before accessing the page!");
            history.push("/home")
        });
    }, [restaurantId])

    const changeFormatted = () => {
        return restaurantAddress.address + ', ' + restaurantAddress.city + ', ' +
            restaurantAddress.state + ', ' + restaurantAddress.postal_code
    }
    const  addressChangeHandler = (event) => {
        setRestaurantAddress({...restaurantAddress,address: event.target.value, formatted: changeFormatted() })
    }
    const  cityChangeHandler = (event) => {
        setRestaurantAddress({...restaurantAddress,city: event.target.value, formatted: changeFormatted()})
    }
    const  stateChangeHandler = (event) => {
        setRestaurantAddress({...restaurantAddress,state: event.target.value, formatted: changeFormatted() })
    }
    const  postalCodeChangeHandler = (event) => {
        setRestaurantAddress({...restaurantAddress,postal_code: event.target.value,formatted: changeFormatted() })
    }
    const  streetChangeHandler = (event) => {
        setRestaurantAddress({...restaurantAddress,street: event.target.value, formatted: changeFormatted() })
    }

    const  latChangeHandler = (event) => {
        setGeo({...geo,lat: event.target.value })
    }
    const lonChangeHandler = (event) => {
        setGeo({...geo,lon: event.target.value })
    }

    const saveRestaurantHandler = () => {
        let restaurantLoc = {...restaurant, address:{...restaurantAddress}, geo: {...geo}, cuisines: ['General']}
        let menus = []
        let menu_sections= []
        let sections = {}
        for (let i = 0; i < menuItems.length; i++) {
            if(sections[menuItems[i].section_name]){
                sections[menuItems[i].section_name].push({
                    name: menuItems[i].name,
                    description: menuItems[i].description,
                    pricing: [
                        {
                            price: parseFloat(menuItems[i].price),
                            currency: "USD",
                            priceString: "$"+menuItems[i].price
                        }
                    ],
                    price: menuItems[i].price
                })
            }
            else{
                sections[menuItems[i].section_name] = [{
                    name: menuItems[i].name,
                    description: menuItems[i].description,
                    pricing: [
                        {
                            price: parseFloat(menuItems[i].price),
                            currency: "USD",
                            priceString: "$"+menuItems[i].price
                        }
                    ],
                    price: menuItems[i].price
                }]
            }
        }


        for(let key in sections){
            let menuSection ={
                section_name: key,
                description: "",
                menu_items: [...sections[key]]
            }
            menu_sections.push(menuSection)
        }
        menus.push( {
            menu_name: "Main",
            menu_sections: [...menu_sections]}
        )
        // setRestaurant({...restaurant, menus: [...menus]})
        restaurantLoc = {...restaurantLoc, menus: [...menus] }
        if(!userId || userId === ""){
            alert("Login as owner before accessing this page!");
            history.push("/home")

        }
        else {
            console.log(restaurantLoc)
            createRestaurant(userId, restaurantLoc).
            then(r => {
                alert("Restaurant details saved, please go to search page and look for the restaurant")
            })
        }
    }

    const items = menuItems.map((item, index) =>
        <li className={"list-group-item"} key={index}>
            <div className={"row"}>
                <div className={"col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3"}>
                    <label className={"text-primary"}>{item.name}</label>
                </div>
                <div className={"col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3"}>
                    <label className={""}>{item.description}</label>
                </div>
                <div className={"col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3"}>
                    <label className={""}>{item.section_name}</label>
                </div>
                <div className={"col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3"}>
                    <label className={"badge bg-primary rounded-pill"}>{item.price}</label>
                </div>
                <div className={"col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3"}>
                    <button className={"btn btn-outline-danger"} onClick={() => deleteItemClickHandler(item)}>
                        Delete
                    </button>
                </div>
            </div>
        </li>
    );

    return (
        user.uType !== "2" ? <><h1> This page is inaccessible for the current user</h1></> :
        <div className={"row"}>
            <div className={"row"}>
                <NavigationBar />
            </div>
            <div className={"row mt-4"}>
                <span className={"d-flex justify-content-center align-items-center h5"}>Register Restaurant</span>
            </div>
            <div className={"row m-4 p-4"}>
                <div className='row'>
                    <div className='col-12 col-lg-6 col-xl-6 col-xxl-6'>
                        <div className={"row m-1 mb-2"}>
                            <span className={"btn btn-info bg-info d-flex justify-content-center align-items-center"}>Restaurant Details</span>
                        </div>
                        <div className={"row"}>
                            <div className='col-12 col-lg-6 col-xl-6 col-xxl-6'>
                                <input type="text" value={restaurant.restaurant_name}
                                       onChange={(event) => restaurantNameChangeHandler(event)}
                                       className="form-control" placeholder="Restaurant Name" id="restaurant_name" />
                            </div>
                            <div className='col-12 col-lg-6 col-xl-6 col-xxl-6'>
                                <input type="phone" value={restaurant.restaurant_phone}
                                       onChange={(event) => phoneChangeHandler(event)}
                                       className="form-control" placeholder="Restaurant phone" id="restaurant_phone" />
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className='col-12 col-lg-6 col-xl-6 col-xxl-6'>
                                <input type="text" value={restaurant.restaurant_website}
                                       onChange={(event) => websiteChangeHandler(event)}
                                       className="form-control" placeholder="Restaurant website" id="restaurant_website" />
                            </div>
                            <div className='col-12 col-lg-6 col-xl-6 col-xxl-6'>
                                <input type="text" value={restaurant.hours}
                                       onChange={(event) => hoursChangeHandler(event)}
                                       className="form-control" placeholder="hours" id="hours" />
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className='col-12 col-lg-6 col-xl-6 col-xxl-6'>
                                <input type="text" value={restaurant.price_range}
                                       title={"Price currency"}
                                       onChange={(event) => priceChangeHandler(event)}
                                       className="form-control" placeholder="Price currency" id="price_range" />
                            </div>
                            <div className='col-12 col-lg-6 col-xl-6 col-xxl-6'>
                                <input type="number" value={restaurant.restaurant_id}
                                       title={"Restaurant id"}
                                       onChange={(event) => idChangeHandler(event)}
                                       className="form-control" placeholder="Restaurant id" id="restaurant_id" />
                            </div>
                        </div>

                    </div>
                    <div className='col-12 col-lg-6 col-xl-6 col-xxl-6'>
                        <div className={"row m-1 mb-2 btn btn-info d-flex justify-content-center align-items-center bg-info"}>
                            <span>Restaurant Address</span>
                        </div>
                        <div className={"row"}>
                            <div className={"col-12 col-lg-6 col-xl-6 col-xxl-6"}>
                                <input type="text" value={restaurantAddress.address}
                                       onChange={(event) => addressChangeHandler(event)}
                                       className="form-control" placeholder="Address" id="address" />
                            </div>
                            <div className={"col-12 col-lg-6 col-xl-6 col-xxl-6"}>
                                <input type="text" value={restaurantAddress.city}
                                       onChange={(event) => cityChangeHandler(event)}
                                       className="form-control" placeholder="City" id="city" />
                            </div>
                        </div>

                        <div className={"row"}>
                            <div className={"col-12 col-lg-6 col-xl-6 col-xxl-6"}>
                                <input type="text" value={restaurantAddress.state}
                                       onChange={(event) => stateChangeHandler(event)}
                                       className="form-control" placeholder="State" id="state" />
                            </div>
                            <div className={"col-12 col-lg-6 col-xl-6 col-xxl-6"}>
                                <input type="number" value={restaurantAddress.postal_code}
                                       title={"Restaurant Postal code"}

                                       onChange={(event) => postalCodeChangeHandler(event)}
                                       className="form-control" placeholder="Postal code" id="postal_code" />
                            </div>
                        </div>

                        <div className={"row"}>
                            <div className={"col-12 col-lg-6 col-xl-6 col-xxl-6"}>
                                <input type="text" value={restaurantAddress.street}
                                       onChange={(event) => streetChangeHandler(event)}
                                       className="form-control" placeholder="Street" id="street" />
                            </div>
                            <div className={"col-12 col-lg-6 col-xl-6 col-xxl-6"}>
                                <input type="text" value={restaurantAddress.formatted}

                                       disabled={true}
                                       className="form-control" placeholder="Formatted" id="formatted" />
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col-12 col-lg-6 col-xl-6 col-xxl-6"}>
                                <input type="number" value={geo.lat}
                                       title={"Restaurant Latitude"}
                                       onChange={(event) => latChangeHandler(event)}
                                       className="form-control" placeholder="Latitude" id="lat" />
                            </div>
                            <div className={"col-12 col-lg-6 col-xl-6 col-xxl-6"}>
                                <input type="number" value={geo.lon}
                                       title={"Restaurant Longitude"}
                                       onChange={(event) => lonChangeHandler(event)}
                                       className="form-control" placeholder="Longitude" id="lon" />
                            </div>
                        </div>
                    </ div>
                </div>
                <div className={"row me-4"}>
                    <ul className={"list-group  mt-4"}>
                        <li className={"list-group-item d-none d-lg-block d-xl-block d-xxl-block"}>
                            <div className={"row justify-content-center"}>
                                <div className={"col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3"}>
                                    <label className={"col-form-label"}>Item Name</label>
                                </div>
                                <div className={"col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3"}>
                                    <label className={"col-form-label"}>Description</label>
                                </div>
                                <div className={"col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 col-xxl-2"}>
                                    <label className={"col-form-label"}>Section Name</label>
                                </div>
                                <div className={"col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 col-xxl-2"}>
                                    <label className={"col-form-label"}>Item Price</label>
                                </div>
                                <div className={"col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 col-xxl-2"}>
                                    <label className={"col-form-label"}>Action</label>
                                </div>
                            </div>
                        </li>
                        <li className={"list-group-item"} key={-1}>
                            <div className={"row"}>
                                <div className={"col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 ps-0"}>
                                    <input className={"form-control "} type="text" placeholder={"Name"} value={menuItem.name}
                                           onChange={(event) => itemNameChangeHandler(event)} />
                                </div>
                                <div className={"col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 ps-0"}>
                                    <input className={"form-control"} type="text" placeholder={"Description"}  value={menuItem.description}
                                           onChange={(event) => itemDescChangeHandler(event)} />
                                </div>
                                <div className={"col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 col-xxl-2 ps-0"}>
                                    <input className={"form-control"} type="text" placeholder={"Section Name"}  value={menuItem.section_name}
                                           onChange={(event) => itemSectionChangeHandler(event)} />
                                </div>
                                <div className={"col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 col-xxl-2 ps-0"}>
                                    <div className="input-group mb-3">
                                        <span className="input-group-text">$</span>
                                        <input className={"form-control"} type="number" placeholder={"Price"}
                                               value={menuItem.price}
                                               onChange={(event) => itemPriceChangeHandler(event)} />
                                    </div>

                                </div>
                                <div className={"col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 col-xxl-2"}>
                                    <button className={"btn btn-info"} onClick={() => addItemClickHandler()}>Add</button>
                                </div>
                            </div>
                        </li>
                        {items}
                    </ul>
                </div>

                <div className={"row mt-4"}>
                    <div className={"col-10"}/>
                    <div className={"col-2"}>
                        <button className={"btn btn-success"} onClick={saveRestaurantHandler}>Save</button>
                    </div>
                </div>
            </div>

        </div>
    )
}
